module.exports = __webpack_public_path__ + "static/media/googleplay.c1190a21.svg";